/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const attachmentDtoSchema = z.object({
  id: z.optional(z.string()),
  filename: z.optional(z.string()),
  kind: z.optional(
    z
      .enum([
        "Deck",
        "Financials",
        "BusinessPlan",
        "Video",
        "OnePager",
        "Other",
      ])
      .default("Deck"),
  ),
  sizeKb: z.optional(z.int()),
  status: z.optional(z.enum(["Uploaded", "Missing"]).default("Uploaded")),
  label: z.optional(z.string()),
});
